import YouTubePlayer from 'youtube-player';

class VideoPlayer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let player;
    if (this.querySelector('#youtube-player')) {
      player = YouTubePlayer(this.querySelector('#youtube-player'));

      player.loadVideoById(
        this.querySelector('#youtube-player').getAttribute('youtube-id')
      );
      player.stopVideo().then(() => {
        console.log('paused');
      });
    }
    if (this.querySelector('.youtube-button')) {
      this.querySelector('.youtube-button').addEventListener('click', (e) => {
        e.preventDefault();
        this.querySelector('.youtube-modal').classList.remove('hidden');
        player.playVideo();
      });
    }
    if (this.querySelector('.youtube-modal')) {
      this.querySelector('.youtube-modal').addEventListener('click', (e) => {
        if (!e.target.classList.contains('video-container')) {
          if (this.querySelector('.youtube-modal')) {
            this.querySelector('.youtube-modal').classList.add('hidden');
          }
          player.stopVideo().then(() => {
            console.log('paused');
          });
        }
      });
    }
  }
}
customElements.define('video-player', VideoPlayer);
